import { OnBoardingInstrument } from '../../../contracts/onboarding/onboarding-instrument.model';
import { OnBoardingAnalyte } from '../../../contracts/onboarding/onboarding-analyte.model';
import { OnBoardingHeaderInfoState } from '../../../contracts/onboarding/onboarding-header-info-state.model';

export interface IOnBoardingState {
    labId: number;
    refreshData: boolean;
    inProgress: boolean;
    sidePanelSelectedTab: 'instrument' | 'analyte';
    headerInfo: OnBoardingHeaderInfoState;
    instruments: OnBoardingInstrument[];
    analytes: OnBoardingAnalyte[];
}

const initialState: IOnBoardingState = {
    labId: 0,
    refreshData: false,
    inProgress: false,
    sidePanelSelectedTab: 'instrument',
    headerInfo: null,
    instruments: [],
    analytes: []
};



export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/onboarding/IOnboardingState.ts